class BoothType {

  /** @type {String} */
  type = ''

  /** @type {String} */
  css_class = ''

  /** @type {String} */
  translation_key = ''

  /** @type {String} */
  number_of_walls = 0

  constructor(type, cssClass, translationKey, numberOfWalls) {
    this.type = type
    this.css_class = cssClass
    this.translation_key = translationKey
    this.number_of_walls = numberOfWalls
  }
}

export default BoothType;